import { useState } from 'react';
import { useToasts } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { Endpoints } from '@brg/api';
import { MAX_FILE_SIZE, UploadProgress } from './constants';

export const useFileUpload = () => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const [uploadProgress, setUploadProgress] = useState<UploadProgress>({});

  const uploadFileToServer = async (file: File, platform: string): Promise<string | null> => {
    return new Promise((resolve, reject) => {
      // Устанавливаем состояние загрузки для конкретной платформы
      setUploadProgress(prev => ({
        ...prev,
        [platform]: { progress: 0, isUploading: true }
      }));

      const allowedFileTypes = platform === 'unity' ? ['.unitypackage'] : ['.zip'];

      // @ts-ignore
      const uppy = new Uppy({
        restrictions: {
          maxFileSize: MAX_FILE_SIZE,
          allowedFileTypes,
        },
      }).use(Tus, {
        endpoint: `${Endpoints.uploader}/upload/`,
        chunkSize: 4194304,
      });

      // Сохраняем ссылку на uppy для возможности отмены
      setUploadProgress(prev => ({
        ...prev,
        [platform]: { progress: 0, isUploading: true, uppy }
      }));

      // Запускаем постепенное заполнение прогресс-бара
      let progress = 0;
      const progressInterval = setInterval(() => {
        progress += 2; // Увеличиваем на 2% каждые 100ms
        if (progress >= 100) {
          progress = 100;
          clearInterval(progressInterval);
        }
        setUploadProgress(prev => ({
          ...prev,
          [platform]: { ...prev[platform], progress, progressInterval }
        }));
      }, 100);

      uppy.on('upload-progress', (file: any, progress: any) => {
        // Не используем реальный прогресс, оставляем наш искусственный
      });

      uppy.on('complete', (result: any) => {
        // Очищаем интервал прогресса
        if (progressInterval) {
          clearInterval(progressInterval);
        }
        
        if (result?.successful?.length) {
          const uploadURL = result.successful[0].uploadURL;
          const fileId = uploadURL.split('/').pop();
          setUploadProgress(prev => ({
            ...prev,
            [platform]: { progress: 100, isUploading: false }
          }));
          setTimeout(() => {
            setUploadProgress(prev => {
              const newState = { ...prev };
              delete newState[platform];
              return newState;
            });
            resolve(fileId);
          }, 500);
        } else {
          reject(new Error('Upload failed'));
        }
        uppy.close();
      });

      uppy.on('error', (error: any) => {
        // Очищаем интервал прогресса
        if (progressInterval) {
          clearInterval(progressInterval);
        }
        
        setUploadProgress(prev => {
          const newState = { ...prev };
          delete newState[platform];
          return newState;
        });
        reject(error);
        uppy.close();
      });

      try {
        // Определяем MIME-тип в зависимости от платформы
        const mimeType = platform === 'unity' 
          ? (file.type || 'application/octet-stream')
          : (file.type || 'application/zip');

        uppy.addFile({
          source: 'file input',
          name: file.name,
          type: mimeType,
          data: file,
          meta: {
            contentType: mimeType,
          },
        });
        uppy.upload();
      } catch (err) {
        // Очищаем интервал прогресса
        if (progressInterval) {
          clearInterval(progressInterval);
        }
        
        setUploadProgress(prev => {
          const newState = { ...prev };
          delete newState[platform];
          return newState;
        });
        reject(err);
        uppy.close();
      }
    });
  };

  const handleFileUpload = async (platform: string, file: File) => {
    if (file.size > MAX_FILE_SIZE) {
      toasts.error(t('room_launch.file_too_large'));
      return null;
    }

    try {
      const fileId = await uploadFileToServer(file, platform);
      return fileId;
    } catch (error) {
      console.error('File upload error:', error);
      toasts.error(t('common.error.saving_data'));
      return null;
    }
  };

  const handleCancelUpload = (platform: string) => {
    const uploadState = uploadProgress[platform];
    
    // Очищаем интервал прогресса
    if (uploadState?.progressInterval) {
      clearInterval(uploadState.progressInterval);
    }
    
    // Отменяем загрузку Uppy
    if (uploadState?.uppy) {
      uploadState.uppy.cancelAll();
      uploadState.uppy.close();
    }
    
    setUploadProgress(prev => {
      const newState = { ...prev };
      delete newState[platform];
      return newState;
    });
  };

  const hasActiveUploads = Object.values(uploadProgress).some(state => state.isUploading);

  return {
    uploadProgress,
    hasActiveUploads,
    handleFileUpload,
    handleCancelUpload,
  };
};
import { useState } from 'react';
import { useToasts } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { Endpoints } from '@brg/api';
import { MAX_FILE_SIZE, UploadProgress } from './constants';

export const useFileUpload = () => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const [uploadProgress, setUploadProgress] = useState<UploadProgress>({});

  const uploadFileToServer = async (file: File, platform: string): Promise<string | null> => {
    return new Promise((resolve, reject) => {
      // Устанавливаем состояние загрузки для конкретной платформы
      setUploadProgress(prev => ({
        ...prev,
        [platform]: { progress: 0, isUploading: true }
      }));

      const allowedFileTypes = platform === 'unity' ? ['.unitypackage'] : ['.zip'];

      // @ts-ignore
      const uppy = new Uppy({
        restrictions: {
          maxFileSize: MAX_FILE_SIZE,
          allowedFileTypes,
        },
      }).use(Tus, {
        endpoint: `${Endpoints.uploader}/upload/`,
        chunkSize: 4194304,
      });

      // Сохраняем ссылку на uppy для возможности отмены
      setUploadProgress(prev => ({
        ...prev,
        [platform]: { progress: 0, isUploading: true, uppy }
      }));

      // Запускаем постепенное заполнение прогресс-бара
      let progress = 0;
      const progressInterval = setInterval(() => {
        progress += 2; // Увеличиваем на 2% каждые 100ms
        if (progress >= 100) {
          progress = 100;
          clearInterval(progressInterval);
        }
        setUploadProgress(prev => ({
          ...prev,
          [platform]: { ...prev[platform], progress, progressInterval }
        }));
      }, 100);

      uppy.on('upload-progress', (file: any, progress: any) => {
        // Не используем реальный прогресс, оставляем наш искусственный
      });

      uppy.on('complete', (result: any) => {
        // Очищаем интервал прогресса
        if (progressInterval) {
          clearInterval(progressInterval);
        }
        
        if (result?.successful?.length) {
          const uploadURL = result.successful[0].uploadURL;
          const fileId = uploadURL.split('/').pop();
          setUploadProgress(prev => ({
            ...prev,
            [platform]: { progress: 100, isUploading: false }
          }));
          setTimeout(() => {
            setUploadProgress(prev => {
              const newState = { ...prev };
              delete newState[platform];
              return newState;
            });
            resolve(fileId);
          }, 500);
        } else {
          reject(new Error('Upload failed'));
        }
        uppy.close();
      });

      uppy.on('error', (error: any) => {
        // Очищаем интервал прогресса
        if (progressInterval) {
          clearInterval(progressInterval);
        }
        
        setUploadProgress(prev => {
          const newState = { ...prev };
          delete newState[platform];
          return newState;
        });
        reject(error);
        uppy.close();
      });

      try {
        // Определяем MIME-тип в зависимости от платформы
        const mimeType = platform === 'unity' 
          ? (file.type || 'application/octet-stream')
          : (file.type || 'application/zip');

        uppy.addFile({
          source: 'file input',
          name: file.name,
          type: mimeType,
          data: file,
          meta: {
            contentType: mimeType,
          },
        });
        uppy.upload();
      } catch (err) {
        // Очищаем интервал прогресса
        if (progressInterval) {
          clearInterval(progressInterval);
        }
        
        setUploadProgress(prev => {
          const newState = { ...prev };
          delete newState[platform];
          return newState;
        });
        reject(err);
        uppy.close();
      }
    });
  };

  const handleFileUpload = async (platform: string, file: File) => {
    if (file.size > MAX_FILE_SIZE) {
      toasts.error(t('room_launch.file_too_large'));
      return null;
    }

    try {
      const fileId = await uploadFileToServer(file, platform);
      return fileId;
    } catch (error) {
      console.error('File upload error:', error);
      toasts.error(t('common.error.saving_data'));
      return null;
    }
  };

  const handleCancelUpload = (platform: string) => {
    const uploadState = uploadProgress[platform];
    
    // Очищаем интервал прогресса
    if (uploadState?.progressInterval) {
      clearInterval(uploadState.progressInterval);
    }
    
    // Отменяем загрузку Uppy
    if (uploadState?.uppy) {
      uploadState.uppy.cancelAll();
      uploadState.uppy.close();
    }
    
    setUploadProgress(prev => {
      const newState = { ...prev };
      delete newState[platform];
      return newState;
    });
  };

  const hasActiveUploads = Object.values(uploadProgress).some(state => state.isUploading);

  return {
    uploadProgress,
    hasActiveUploads,
    handleFileUpload,
    handleCancelUpload,
  };
};
